import { WHATS_NEW } from '@/config/whatsNew'

/**
 * The full What's New list.
 *
 * The entries used to live here as 892 lines of hand-written JSX. They now come from
 * `config/whatsNew.tsx` so this page and the WhatsNewDialog render the same thing: two copies of
 * a release-notes list is two copies that disagree within a month, and the one people see first
 * would be whichever got forgotten.
 *
 * Nothing about how it reads has changed. Same titles, same bodies, same order.
 */
export default function WhatsNewSection() {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-3">
        Grackle CRM is actively improving. Here are the most recent features and enhancements:
      </p>

      <div className="space-y-4">
        {WHATS_NEW.map((entry) => (
          <div key={entry.id}>
            <p className="text-sm font-medium mb-1">{entry.title}</p>
            {entry.body}
          </div>
        ))}
      </div>
    </>
  )
}
